import ThemeService from '@/services/themeService';
import { THEME_DARK_MODE, THEME_LIGHT_MODE } from '@/constants/themeConstants';
import Vuetify from '@/plugins/vuetify';

export default {
  getAllThemes() {
    return ThemeService.getAll();
  },

  getTheme() {
    return JSON.parse(localStorage.getItem('theme')) || ThemeService.getDefault();
  },

  build(theme) {
    if (theme && theme._id) {
      ThemeService.get(theme._id)
        .then(retrievedTheme => this.setTheme(retrievedTheme.data || ThemeService.getDefault()))
        .catch(() => this.setTheme(ThemeService.getDefault()));
    } else {
      this.setTheme(ThemeService.getDefault());
    }

    theme.mode === THEME_DARK_MODE ? this.setDarkMode() : this.setLightMode();
  },

  setDarkMode() {
    Vuetify.framework.theme.dark = true;
  },

  setLightMode() {
    Vuetify.framework.theme.dark = false;
  },

  getThemeMode() {
    if (!Vuetify.framework) {
      return THEME_DARK_MODE;
    }
    return Vuetify.framework.theme.dark ? THEME_DARK_MODE : THEME_LIGHT_MODE;
  },

  removeTheme() {
    localStorage.removeItem('theme');
  },

  setTheme(theme) {
    if (!theme) {
      return;
    }
    Vuetify.framework.theme.themes = theme;
    Vuetify.framework.theme.dark = this.getThemeMode() === THEME_DARK_MODE;
    localStorage.setItem('theme', JSON.stringify(theme));
  }
};
